import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../../Config/Config";

export const fetchTestSeriesData = createAsyncThunk(
  "api/testSeries",
  async (courseId) => {
    const response = await fetch(
      `${FULL_API_BASE_URL}/get-test-series-list-active/?course_id=${courseId}`
    );
    const data = await response.json();
    return data;
  }
);

const testSeriesSlice = createSlice({
  name: "testSeries",
  initialState: {
    testSeriesData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestSeriesData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTestSeriesData.fulfilled, (state, action) => {
        state.loading = false;
        state.testSeriesData = action.payload;
      })
      .addCase(fetchTestSeriesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default testSeriesSlice.reducer;
